export const LIST_DRAG_HANDLE_TYPES = {
  DEFAULT: 'default',
  ROW: 'row',
};
